import React from 'react'

const Context = React.createContext({
  isLogin:false, //是否登陆
  setIsLogin(isLogin:boolean){}, //设置登陆
  selectedPlan:[] as any,
  setSelectPlan(keys:any[]){},
  planCheckboxOptions: [] as any,
  setPlanOptions(keys:any[]){},
  needKnow:{},
  setNeedKnow(key:string,value:string|number){},
  tableRely:{}, //mutil-input 与 table的映射关系
  setTableRely(key:string,value:string|number){}, //设置tableRely
  addressList:[{}], //地区信息
  targetFormList:[{}], // 标的信息
  setTargetForm(list:any[]){},
  productTypeData:[],//小微亚马逊产品类型数据,
  documentGroupIdList:[],//上传产品质量认证图片
  initFlag:false, //初始化标示
  setInitSuccess(){}, //设置初始化成功 用于在第一次初始化不成功 后 重新获取productInfo的时候
  selectedSet:0, //当前选择的套餐
  setSelectedSet(set:number){}, //设置当前选择的套餐
  needAddressFresh:false, //初始化不成功是 显示地区输入框 用于重新选择地区 再次拉取productInfo
  handleChooseAddress({cityCode:string,departmentCode:String,address:[]}){},//切换城市
  handleChoosePlaceType({}){}, // 切换场所类型
  handleChoosePackage(set:number){}, // 切换套餐
  addressInfo:{hint:false},
  setProjectCost(set:number|string){}, // 设置工程造价的值
  projectCost:<number|string>(''),
  professionList:[] as any,
  setProfessionList(list:any[]){}, // 设置团意职业数据
  healthNoticeOpen:false,
  setHealthNoticeOpen(open:boolean){},
})

export default Context